export default {
  id: 'charge-codes',
  title: 'Charge Codes',
  category: 'Admin',
  summary: 'Define the tasks employees select when entering time on their timesheets.',
  overview: 'Charge codes (tasks) are the atomic units of time charging. They usually belong to a project and determine where labor cost and billable hours accumulate.',
  howItWorks: [
    'Create a charge code with identifying attributes and project association.',
    'Assign employees who are allowed to charge that code.',
    'Employees add the code to a timesheet (or receive it via auto-add) and enter hours against it.',
    'Inactive or expired codes should not receive new charges.'
  ],
  actions: [
    {
      name: 'Create charge code',
      description: 'Opens the create flow to define a new task for timesheet charging.'
    },
    {
      name: 'Edit charge code details',
      description: 'Updates attributes, dates, and assignments that control who can use the code.'
    }
  ],
  tips: [
    'Clear naming helps employees pick the right code and reduces mischarges.',
    'Use Data Management if you need to reassign historical charges for an employee across a date range.'
  ],
  related: ['projects', 'timesheet', 'data-management']
};



// WEBPACK FOOTER //
// ./client/help/content/charge-codes.js